import React from 'react';
import PropTypes from 'prop-types';
import { CardElement } from 'react-stripe-elements';
import BoxedItem from '../boxed-item';

import './payments.scss';

const CC_BRANDS = ['mastercard', 'visa'];

class AddCreditCard extends React.Component {
  constructor(props) {
    super(props);
    this.select = this.select.bind(this);
  }

  select() {
    if (!this.props.active) {
      this.props.onSelect();
    }
  }

  render() {
    return (
      <BoxedItem
        title="Aggiungi nuova carta"
        icon="bi_interface-plus"
        className="paymentTypeBox"
        active={this.props.active}
        onClick={this.select}
      >
        {this.props.active && <CardElement />}
      </BoxedItem>
    );
  }
}

AddCreditCard.propTypes = {
  active: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
};

export default AddCreditCard;



// WEBPACK FOOTER //
// ./src/components/payment/add-stripe-credit-card.js